<template>
    <div class="content-text-container">
        <div class="conten-section">
            <p>At Charm-Vibe, we are proud to be Australia's first ethical, AI-driven, and community-powered cosmetic platform. Your safety, privacy, and dignity are at the heart of everything we do.</p>
            <p>This consent form outlines how we collect, store, and use your personal and visual information when you engage with our platform for booking doctors, joining consultations, or uploading content (e.g., before/after images). It reflects our commitment to transparency, user control, and compliance with Australian data protection laws.</p>
        </div>
        <div class="conten-section">
            <h3>1. Age & Identity Verification</h3>
            <p>By proceeding, I confirm that:</p>
            <p>- I am 18 years of age or older.</p>
            <p>- I understand Charm-Vibe is a verified cosmetic platform and access is restricted to adult users seeking or sharing medical and aesthetic services.</p>
        </div>
        <div class="conten-section">
            <h3>2. Collection of Images and Personal Data</h3>
            <p>I understand and agree that:</p>
            <p>- Charm-Vibe will collect personal details (name, DOB, contact info), optional images (e.g. selfies, medical condition photos), and health-related consultation data that I voluntarily provide.</p>
            <p>- The collection is for cosmetic healthcare purposes only, including:</p>
            <p>- Professional consultations and diagnosis</p>
            <p>- Secure profile creation</p>
            <p>- Educational and community participation features</p>
        </div>
        <div class="conten-section">
            <h3>3. Storage and Security of Data</h3>
            <p>Charm-Vibe uses the highest standards of data security and regulatory compliance:</p>
            <p>- All data is stored in accordance with the Privacy Act 1988 and Australian Privacy Principles (APPs).</p>
            <p>- Images are securely encrypted, stored on protected servers, and only accessible to verified doctors or platform admins.</p>
            <p>- Audit logs are maintained to track who accesses or modifies data.</p>
        </div>
        <div class="conten-section">
            <h3>4. Use of Uploaded Images</h3>
            <p>I understand that:</p>
            <p>- Any photos or treatment images I upload may be used for:</p>
            <p class="sub-item">- Medical consultations with licensed professionals</p>
            <p class="sub-item">- Internal documentation</p>
            <p class="sub-item">- Educational resources within the platform (e.g., verified before/after galleries)</p>
            <p>- My images will never be used in external promotions, marketing, or social media without separate, signed permission.</p>
            <p>- Any public usage will require an additional written consent form, which I can accept or decline freely.</p>
        </div>
        <div class="conten-section">
            <h3>5. Withdrawing Consent</h3>
            <p>I understand that:</p>
            <p>- I may withdraw my consent at any time by contacting support@charm-vibe.com</p>
            <p>- Upon request, Charm-Vibe will permanently delete my stored images or profile, unless retention is legally required.</p>
            <p>- Charm-Vibe will process removal requests promptly, typically within 7 business days.</p>
        </div>
        <div class="conten-section">
            <h3>6. Third-Party Content & Misuse</h3>
            <p>I agree to:</p>
            <p>- Only upload images of myself, unless I have clear, written consent from another person (e.g. friends, family).</p>
            <p>- Not impersonate or upload stock images, celebrity photos, or false content.</p>
            <p>- Respect community guidelines and comply with ethical behavior expected on a medical platform.</p>
        </div>
        <div class="conten-section">
            <h3>7. Screenshot & Privacy Protections</h3>
            <p>To protect privacy:</p>
            <p>- Charm-Vibe disables screenshot functionality on sensitive image pages and consultation chats (where supported by device/browser).</p>
            <p>- Any attempt to record, save, or redistribute private content is strictly prohibited.</p>
            <p>- The platform maintains detailed logs of access and usage to detect violations.</p>
        </div>
        <div class="conten-section">
            <h3>8. Charitable Purpose of Data Use</h3>
            <p>I acknowledge that:</p>
            <p>- Charm-Vibe is a non-profit initiative, and 100% of booking and subscription profits go to approved charities (e.g., surgical assistance, confidence restoration, cancer recovery programs).</p>
            <p>- My responsible use of this platform contributes to social good, and my participation supports verified causes.</p>
        </div>
    </div>
</template>
<script lang="ts" setup></script>
<style lang="scss" scoped>
.content-text-container{
    .conten-section{
        h3{
            color: #000000;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: 24px; 
        }
        p{
            color: #000000;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px; 
            word-wrap: break-word;
        }

        .sub-item{
            text-indent: 12px;
        }
    }
}
</style>
